import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function CookiePolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
    const previous = document.title;
    document.title = "Cookie Policy — Estetica Elite";
    return () => {
      document.title = previous;
    };
  }, []);

  return (
    <article className="ee-policy-page">
      <div className="ee-policy-container">
        <h1>Cookie Policy</h1>
        <p className="ee-policy-meta">
          <strong>Ultimo aggiornamento:</strong> 16 maggio 2026
        </p>

        <p>
          La presente Cookie Policy descrive l'utilizzo dei cookie sul sito
          esteticaelite.eu (di seguito, il "Sito") da parte di ELITE S.n.c. di
          Fanton Paola e Fontolan Erika, nel rispetto del Regolamento UE
          2016/679 (GDPR) e delle Linee Guida del Garante per la Protezione dei
          Dati Personali del 10 giugno 2021.
        </p>

        <h2>1. Cosa sono i Cookie</h2>
        <p>
          I cookie sono piccoli file di testo che i siti web visitati inviano
          al browser dell'utente, dove vengono memorizzati per essere poi
          ritrasmessi agli stessi siti durante le visite successive. I cookie
          possono essere classificati come:
        </p>
        <ul>
          <li>
            Cookie tecnici: necessari per il corretto funzionamento del Sito
          </li>
          <li>
            Cookie di profilazione: utilizzati per tracciare il comportamento
            dell'utente a fini di marketing e pubblicità
          </li>
        </ul>
        <p>Il Sito non utilizza cookie di profilazione.</p>

        <h2>2. Tipologie di Cookie utilizzati</h2>

        <h3>Cookie Tecnici (sempre attivi - non richiedono consenso)</h3>
        <p>Sono cookie strettamente necessari al funzionamento del Sito.</p>
        <div className="ee-policy-table-wrap">
          <table>
            <thead>
              <tr>
                <th>Nome</th>
                <th>Scopo</th>
                <th>Durata</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>cc_cookie</td>
                <td>Memorizza le preferenze dell'utente sui cookie</td>
                <td>6 mesi</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>
          Per questi cookie non è richiesto il consenso dell'utente, come
          previsto dall'art. 122 del Codice Privacy.
        </p>

        <h3>Cookie di Servizi Terzi (richiedono consenso)</h3>
        <p>Il Sito utilizza i seguenti servizi di terze parti:</p>

        <h3>Google Maps</h3>
        <ul>
          <li>Fornitore: Google Ireland Limited</li>
          <li>
            Finalità: visualizzazione della mappa interattiva nella sezione
            "Dove siamo"
          </li>
          <li>Categoria: funzionalità</li>
          <li>Durata: variabile (alcuni di sessione, altri fino a 24 mesi)</li>
          <li>
            Privacy Policy:{" "}
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
            >
              policies.google.com/privacy
            </a>
          </li>
        </ul>

        <h3>Google Fonts</h3>
        <ul>
          <li>Fornitore: Google Ireland Limited</li>
          <li>
            Finalità: caricamento dei font tipografici utilizzati nel Sito
          </li>
          <li>Categoria: funzionalità</li>
          <li>Durata: nessun cookie persistente</li>
          <li>
            Privacy Policy:{" "}
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
            >
              policies.google.com/privacy
            </a>
          </li>
        </ul>

        <h2>3. Gestione delle Preferenze sui Cookie</h2>
        <p>
          Al primo accesso al Sito, viene mostrato un banner informativo che
          permette all'utente di:
        </p>
        <ul>
          <li>Accettare tutti i cookie</li>
          <li>Rifiutare tutti i cookie non necessari</li>
          <li>Personalizzare le preferenze per singola categoria</li>
        </ul>
        <p>
          L'utente può modificare le proprie scelte in qualsiasi momento
          cliccando sul link "Preferenze cookie" presente nel footer del Sito.
        </p>

        <h2>4. Disattivazione dei Cookie dal Browser</h2>
        <p>
          L'utente può disabilitare i cookie direttamente dalle impostazioni
          del proprio browser:
        </p>
        <ul>
          <li>
            Google Chrome:{" "}
            <a
              href="https://support.google.com/chrome/answer/95647"
              target="_blank"
              rel="noopener noreferrer"
            >
              support.google.com/chrome/answer/95647
            </a>
          </li>
          <li>
            Mozilla Firefox:{" "}
            <a
              href="https://support.mozilla.org/it/kb/Gestione%20dei%20cookie"
              target="_blank"
              rel="noopener noreferrer"
            >
              support.mozilla.org/it/kb/Gestione dei cookie
            </a>
          </li>
          <li>
            Safari:{" "}
            <a
              href="https://support.apple.com/it-it/guide/safari/sfri11471/mac"
              target="_blank"
              rel="noopener noreferrer"
            >
              support.apple.com/it-it/guide/safari/sfri11471/mac
            </a>
          </li>
          <li>
            Microsoft Edge:{" "}
            <a
              href="https://support.microsoft.com/it-it/microsoft-edge"
              target="_blank"
              rel="noopener noreferrer"
            >
              support.microsoft.com/it-it/microsoft-edge
            </a>
          </li>
        </ul>

        <h2>5. Diritti dell'Utente</h2>
        <p>
          L'utente ha tutti i diritti previsti dal GDPR descritti nella{" "}
          <Link to="/privacy-policy">Privacy Policy</Link>, accessibile dal
          footer del Sito.
        </p>
        <p>
          Per esercitare i propri diritti relativamente ai cookie, l'utente può
          contattare il Titolare all'indirizzo:{" "}
          <a href="mailto:info@esteticaelite.eu">info@esteticaelite.eu</a>
        </p>

        <h2>6. Modifiche alla Cookie Policy</h2>
        <p>
          Il Titolare si riserva il diritto di modificare la presente Cookie
          Policy in qualsiasi momento, dandone comunicazione agli utenti
          tramite pubblicazione sul Sito.
        </p>
      </div>
    </article>
  );
}
